import { X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { fmtMinutes } from "@/lib/interventions";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";

const remove = async (rep, ln, onChanged) => {
  if (!window.confirm(`Togliere "${ln.description}" dal rapportino? L'attività potrà essere riportata di nuovo.`)) return;
  try { await api.delete(`/service-reports/${rep.id}/activity-lines/${ln.activity_id}`); toast.success("Attività tolta dal rapportino"); onChanged?.(); }
  catch (e) { toast.error(errorMessage(e)); }
};

export const ActivityLines = ({ rep, onChanged }) => (
  <Panel className="p-5" data-testid="report-activity-lines">
    <SectionLabel>Attività svolte</SectionLabel>
    {!rep.activity_lines?.length ? <p className="mt-2 text-sm text-slate-500">Nessuna attività riportata. Generale dalla scheda intervento o dall'attività completata.</p> : (
      <ol className="mt-2 divide-y divide-line/60">
        {rep.activity_lines.map((ln, i) => (
          <li key={ln.id} className="py-2.5 text-sm" data-testid={`report-activity-line-${ln.activity_id}`}>
            <div className="flex items-start justify-between gap-2"><p className="font-semibold text-ink">{i + 1}. {ln.description}</p>
              {rep.can?.remove_activity && <Button size="sm" variant="ghost" className="h-7 shrink-0 gap-1 px-2 text-xs text-slate-500 hover:text-red-600" onClick={() => remove(rep, ln, onChanged)} data-testid={`report-activity-remove-${ln.activity_id}`}><X className="h-3.5 w-3.5" />Togli</Button>}</div>
            {ln.details && <p className="mt-0.5 whitespace-pre-line text-slate-600">{ln.details}</p>}
            {ln.outcome && <p className="mt-0.5 text-slate-600"><span className="text-slate-400">Esito:</span> {ln.outcome}</p>}
            {ln.notes && <p className="mt-0.5 text-slate-600"><span className="text-slate-400">Note:</span> {ln.notes}</p>}
            <p className="mt-0.5 text-xs text-slate-500">
              <b className="text-slate-700">Lavorato: {ln.minutes != null ? fmtMinutes(ln.minutes) : "—"}</b>
              {ln.activity_month && rep.period && ln.activity_month !== rep.period ? ` · attività di ${ln.activity_month} (mese chiuso)` : ""}
              {ln.start_at ? ` · ${fmtDateTime(ln.start_at)}` : ""}
              {ln.completed_at ? `${ln.start_at ? " · " : ""}completata ${fmtDateTime(ln.completed_at)}` : ""}
            </p>
          </li>
        ))}
      </ol>
    )}
  </Panel>
);
